import React from "react";
import classnames from "classnames";

import { useStorage } from "../../hooks/useStorage";
import { IconButton } from "../index";
import { ArrowRight } from "../Icons";
import styles from "./CollapseComponent.module.scss";

export interface Props {
  storageKey: string;
  children?: React.ReactNode;
}

const CollapseComponent = (props: Props) => {
  const { storageKey, children } = props;
  const [isCollapsed, setCollapsed] = useStorage(storageKey, false);

  return (
    <div
      className={classnames(
        styles.collapse,
        isCollapsed && styles.collapseCollapsed
      )}
    >
      <IconButton
        id="sidebar-collapse-button"
        aria-label="Collapse Button"
        className={classnames(
          styles.collapseButton,
          isCollapsed && styles.collapseButtonLeft
        )}
        onClick={() => setCollapsed(!isCollapsed)}
      >
        <ArrowRight fillColor={null} />
      </IconButton>
      {!isCollapsed && children}
    </div>
  );
};

export default CollapseComponent;
